import * as React from 'react';
import { FUtil, FServiceAPI } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import FResourceTypeInput4 from '@/components/FResourceTypeInput4';

interface FResourceTypeInputBlockProps {
  value: string;
  disabled?: boolean;

  onChange?(value: string): void;
}

export function FResourceTypeInputBlock({
  value,
  onChange,
  disabled = false,
}: FResourceTypeInputBlockProps) {
  const [$value, set$value, get$value] = FUtil.Hook.useGetState<null | {
    value: string;
    labels: string[];
    customInput?: string;
  }>(null);

  AHooks.useDebounceEffect(
    () => {
      if (value === '') {
        set$value(null);
        return;
      }
      if (value === $value?.value) {
        return;
      }
      handleValue();
    },
    [value],
    {
      wait: 0,
    },
  );

  async function handleValue() {
    const {
      data,
    }: {
      data: {
        parentInfo: {
          parentChain: {
            code: string;
            name: string;
          }[];
        };
      };
    } = await FServiceAPI.ResourceType.getInfoByCode({
      code: value,
    });
    // console.log(data, 'sidojflksdjlkfjldskjfksdjflskdjflkjlkj');
    set$value({
      value: value,
      labels: data.parentInfo.parentChain
        .map((pc) => {
          return pc.name;
        })
        .reverse(),
    });
  }

  return (
    <div style={{ width: 420 }}>
      <FResourceTypeInput4
        width={420}
        disabled={disabled}
        // disabled={true}
        onlySelect={true}
        value={$value}
        onChange={async (value) => {
          set$value(value);
          onChange && onChange(value?.value || '');
        }}
        showAddNewType={true}
      />
    </div>
  );
}
